import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DefaultPermissions } from '../models/defaultPermissions.model';
import { DeleteAccess } from '../models/deleteAccess.model';
import { User } from '../models/user.model';
import {skip} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PermissionsState {
    private users$ = new BehaviorSubject<User[]>(null);
    private tempUsers: any[] = [];

    private defaultWorkspaceRoles$ = new BehaviorSubject<any>(null);
    private permissionsGroupType$ = new BehaviorSubject<any>(null);
    private permissionType$ = new BehaviorSubject<string>(null);

    private totalPages$ = new BehaviorSubject<number>(null);
    private pageNumber$ = new BehaviorSubject<number>(1);

    private newAccessDashboard$ = new BehaviorSubject<any>(null);
    private newAccessDataSource$ = new BehaviorSubject<any>(null);
    private newAccessDashboardGroup$ = new BehaviorSubject<any>(null);

    private isChartPermissionsUpdated$ = new BehaviorSubject<boolean>(false);


    // update BehaviorSubjects
    updatePermissionType(permissionGroupType: string) {
        this.permissionType$.next(permissionGroupType);

    }

    setDefaults() {
        this.users$.next(null);
        this.defaultWorkspaceRoles$.next(null);
        this.permissionsGroupType$.next(null);
        this.permissionType$.next(null);

        this.totalPages$.next(null);
        this.pageNumber$.next(1);

        this.newAccessDashboard$.next(null);
        this.newAccessDataSource$.next(null);
        this.newAccessDashboardGroup$.next(null);

        this.tempUsers = [];
    }

    updatePermissions(permissionGroupType: string): void {
      const defaultPermissions = new DefaultPermissions();
        let permissions;
        let permissionsDashboard;
        switch (permissionGroupType) {
            case 'Dashboard':
                permissions = defaultPermissions.permissions.
                    filter(permission => permission.id >= 200 && permission.id <= 299);
                this.permissionsGroupType$.next(permissions);
                break;
            case 'DashboardGroup':
                permissions = defaultPermissions.permissions.
                    filter(permission => permission.id >= 100 && permission.id <= 199);
                permissionsDashboard = defaultPermissions.permissions.
                    filter(permission => permission.id >= 200 && permission.id <= 299);
                this.permissionsGroupType$.next([permissions, permissionsDashboard]);
                break;
            case 'DataSource':
                permissions = defaultPermissions.permissions.
                    filter(permission => permission.id >= 400 && permission.id <= 499);
                this.permissionsGroupType$.next(permissions);
                break;
          case 'Chart':
            permissions = defaultPermissions.permissions.
            filter(permission => permission.id >= 500 && permission.id <= 599);
            this.permissionsGroupType$.next(permissions);
            break;
        }
    }

    updateDefaultWorkspaceRoles(permissionGroupType: string, roles: any[]): void {
        const tempRoles = [];
        if (permissionGroupType === 'DashboardGroup') {
            roles.forEach(role => {
                const tempRole = { ...role };
                tempRole.permissions = this.filterData('DashboardOfGroup', role.permissions);
                tempRoles.push(tempRole);
            });
            roles.forEach(role => role.permissions = this.filterData(permissionGroupType, role.permissions));
            this.defaultWorkspaceRoles$.next([roles, tempRoles]);
        } else {
            roles.forEach(role => role.permissions = this.filterData(permissionGroupType, role.permissions));
            this.defaultWorkspaceRoles$.next(roles);
        }
    }

    updateUsers(users: User[]): void {
        if(this.defaultWorkspaceRoles$?.value !== null && this.permissionsGroupType$?.value !== null) {
          if(this.users$.value !== null) {
            this.tempUsers = [...this.users$?.value];
          }
            let permissionType = '';
            const defaultRoles = [...this.defaultWorkspaceRoles$?.value];
            const defaultPermissions = [...this.permissionsGroupType$?.value];
            permissionType = this.permissionType$?.value;
            users.forEach((user,userIndex) => {
                if (user.accessRecipientType !== 'Group') {
                    if (!user.highestLevel.isRole) {
                        user.permissionsBlocked = this.filterData(permissionType, user.highestLevel.permissions);
                    } else {
                        const foundIndexRole = defaultRoles.findIndex(role => role.id ===  user.highestLevel.roleId);
                        if(foundIndexRole > -1) {
                            const role = defaultRoles[foundIndexRole];
                            user.permissionsBlocked =this.filterData(permissionType, role.permissions);
                        } else {
                            users.splice(userIndex,1);
                            return;
                        }
                    }
                } else {
                    const temp = [];
                    defaultPermissions.forEach(permission => {
                        temp.push(permission.id);
                    });
                    user.permissionsBlocked = temp;
                }
                if (!user.isRole) {
                    user.permissionsSelected = this.filterData(permissionType, user.permissions);

                } else {
                    const foundIndexRole = defaultRoles.findIndex(role => role.id ===  user.roleId);
                    if(foundIndexRole > -1) {
                        const role = defaultRoles[foundIndexRole];
                        user.permissionsSelected =this.filterData(permissionType, role.permissions);
                    } else {
                        user.isRole = false;
                        user.permissionsSelected = [];
                    }
                }
                this.mapPermissionsDashboardOrDataSource(user, permissionType);
            });
            this.users$.next(users);
        }
    }

    updateUsersDashboardGroup(users: User[]): void {
      if(this.defaultWorkspaceRoles$?.value !== null && this.permissionsGroupType$?.value !== null) {

        if(this.users$.value !== null) {
          this.tempUsers = [...this.users$?.value];
        }
        let permissionType = '';
        const defaultRoles = [...this.defaultWorkspaceRoles$?.value];
        const defaultPermissions = [...this.permissionsGroupType$?.value];
        permissionType = this.permissionType$?.value;
        users.forEach((user, userIndex) => {
          user.permissionsBlocked = { dashboard: [], dashboardGroup: [] };
          user.permissionsSelected = { dashboard: [], dashboardGroup: [] };
          if (user.accessRecipientType !== 'Group') {
            if (!user.highestLevel.isRole) {
              user.permissionsBlocked.dashboardGroup =
                this.filterData(permissionType, user.highestLevel.permissions);
              user.permissionsBlocked.dashboard =
                this.filterData('DashboardOfGroup', user.highestLevel.permissions);
            } else {
              const foundIndexRoleDashboardGroup =
                defaultRoles[0].findIndex(role => role.id ===  user.highestLevel.roleId);
              const foundIndexRoleDashboard =
                defaultRoles[1].findIndex(role => role.id ===  user.highestLevel.roleId);
              if(foundIndexRoleDashboardGroup > -1 && foundIndexRoleDashboard> -1) {
                user.permissionsBlocked.dashboardGroup =
                  this.filterData(permissionType, defaultRoles[0][foundIndexRoleDashboardGroup].permissions);
                user.permissionsBlocked.dashboard =
                  this.filterData('DashboardOfGroup',  defaultRoles[1][foundIndexRoleDashboard].permissions);
              } else {
                users.splice(userIndex,1);
                return;
              }
            }
          } else {
            let temp = [];
            defaultPermissions[0].forEach(permission => {
              temp.push(permission.id);
            });
            user.permissionsBlocked.dashboardGroup = temp;
            temp = [];
            defaultPermissions[1].forEach(permission => {
              temp.push(permission.id);
            });
            user.permissionsBlocked.dashboard = temp;
          }
          if (!user.isRole) {
            user.permissionsSelected.dashboardGroup = this.filterData(permissionType, user.permissions);
            user.permissionsSelected.dashboard = this.filterData('DashboardOfGroup', user.permissions);

          } else {
            const foundIndexRoleDashboardGroup =
              defaultRoles[0].findIndex(role => role.id ===  user.roleId);
            const foundIndexRoleDashboard =
              defaultRoles[1].findIndex(role => role.id ===  user.roleId);
            if(foundIndexRoleDashboardGroup > -1 && foundIndexRoleDashboard> -1) {
              user.permissionsSelected.dashboardGroup =
                this.filterData(permissionType, defaultRoles[0][foundIndexRoleDashboardGroup].permissions);
              user.permissionsSelected.dashboard =
                this.filterData('DashboardOfGroup',  defaultRoles[1][foundIndexRoleDashboard].permissions);
            } else {
              user.isRole = false;
              user.permissionsSelected.dashboardGroup =[];
              user.permissionsSelected.dashboard =[];
            }
          }
          this.mapPermissionsDashboardGroup(user);
        });
        this.users$.next(users);
      }
    }

    updateUserPermissions(roleId: string, userIndex: number, modifiedPermissions: any, isExist: boolean): void {
        this.tempUsers = [...this.users$?.value];
        const updateUsers = [...this.users$.value];
        const user = {... updateUsers[userIndex]};
        user.permissionsSelected = modifiedPermissions;
        user.isRole = isExist;
        user.roleId = roleId;
        updateUsers[userIndex] = user;
        this.users$.next(updateUsers);
    }

    updateTotalPages(totalPages: number): void {
        this.totalPages$.next(totalPages);
    }

    updatePageNumber(pageNumber: number): void {
        this.pageNumber$.next(pageNumber);
    }


    updateNewAccessDashboard(users: any[]) {
        const defaultPermissions = [...this.permissionsGroupType$.value];
        users.forEach(user => {
            user.permissionsBlocked = [];
            if (user.userType !== 'Group') {
                if (!user.highestLevel[0].isRole) {
                    user.permissionsBlocked.push(
                        this.filterData('Dashboard', user.highestLevel[0].permissions),
                    );
                } else {
                    this.findRole('Dashboard', user.highestLevel[0].roleId).forEach(permission => {
                        user.permissionsBlocked.push(permission);
                    });
                }
            } else {
                defaultPermissions.forEach(permission => {
                    user.permissionsBlocked.push(permission.id);
                });

            }
            const permissions = new DefaultPermissions();
            user.permissionsBlocked = permissions.mapSpecificPermissions(user.permissionsBlocked,'Dashboard',true);
        });

        this.newAccessDashboard$.next(users);
    }

    updateNewAccessDataSource(users) {
        const defaultPermissions = [...this.permissionsGroupType$.value];
        users.forEach(user => {
            user.permissionsBlocked = [];
            if (user.userType !== 'Group') {
                if (!user.highestLevel[0].isRole) {
                    user.permissionsBlocked.push(
                        this.filterData('DataSource', user.highestLevel[0].permissions),
                    );
                } else {
                    this.findRole('DataSource', user.highestLevel[0].roleId).forEach(permission => {
                        user.permissionsBlocked.push(permission);
                    });
                }
            } else {
                defaultPermissions.forEach(permission => {
                    user.permissionsBlocked.push(permission.id);
                });

            }
            const permissions = new DefaultPermissions();
            user.permissionsBlocked = permissions.mapSpecificPermissions(user.permissionsBlocked,'DataSource',true);
        });
        this.newAccessDataSource$.next(users);
    }

    updateNewAccessDashboardGroup(users) {
        const defaultPermissions = [...this.permissionsGroupType$.value];
        users.forEach(user => {
            const permissionsBlocked = [];
            user.permissionsBlocked = {
              dashboard: [],
              dashboardGroup: [],
            };
            if (user.userType !== 'Group') {
                if (!user.highestLevel[0].isRole) {
                    permissionsBlocked.push(
                        this.filterData('DashboardGroup', user.highestLevel[0].permissions),
                    );
                    permissionsBlocked.push(
                        this.filterData('Dashboard', user.highestLevel[0].permissions),
                    );
                } else {
                    this.findRole('DashboardGroup', user.highestLevel[0].roleId).forEach(permissionsTemp => {
                        permissionsBlocked.push(permissionsTemp);
                    });
                }
            } else {
                defaultPermissions.forEach(permissionsTemp => {
                    const temp = [];
                    permissionsTemp.forEach(permission => {
                        temp.push(permission.id);
                    });
                    permissionsBlocked.push(temp);
                });
            }
            const permissions = new DefaultPermissions();
            user.permissionsBlocked.dashboardGroup =
              permissions.mapSpecificPermissions(permissionsBlocked[0],'DashboardGroup',true);
            user.permissionsBlocked.dashboard =
              permissions.mapSpecificPermissions(permissionsBlocked[1],'Dashboard',true);
        });
        this.newAccessDashboardGroup$.next(users);
    }

    // getters Observable
    getUsers$(): Observable<any> {
        return this.users$.asObservable().pipe(skip(1));
    }

    getWorkspaceRoles$(): Observable<any> {
        return this.defaultWorkspaceRoles$.asObservable().pipe(skip(1));
    }

    getPermissionsGroupType$(): Observable<any> {
        return this.permissionsGroupType$.asObservable();
    }

    getTotalPages$(): Observable<any> {
        return this.totalPages$.asObservable().pipe(skip(1));
    }

    getPageNumber$(): Observable<any> {
        return this.pageNumber$.asObservable().pipe(skip(1));
    }

    getNewAccessDashboard$(): Observable<any> {
        return this.newAccessDashboard$.asObservable();
    }

    getNewAccessDataSource$(): Observable<any> {
        return this.newAccessDataSource$.asObservable();
    }

    getNewAccessDashboardGroup$(): Observable<any> {
        return this.newAccessDashboardGroup$.asObservable();
    }

    setIsChartPermissionsUpdated(): void {
        if(!this.isChartPermissionsUpdated$.getValue()) {
            this.isChartPermissionsUpdated$.next(true);
        }
    }

    updateIsChartPermissionsUpdated(isUpdated: boolean): void {
        this.isChartPermissionsUpdated$.next(isUpdated);
    }

    getIsChartPermissionsUpdated$(): Observable<boolean> {
        return this.isChartPermissionsUpdated$.asObservable();
    }

    // delete
    deleleUserAccess(body: DeleteAccess): number {
        this.tempUsers = [...this.users$.value];
        let users = [...this.users$.value];
        users = users.filter(user => user.id !== body.accessId);
        this.users$.next(users);
        return users.length;
    }
    // roll backs
    rollbackUsersPermissions() {
        this.users$.next(this.tempUsers);
        this.tempUsers = null;
    }

    //private methods
    private filterData(permissionGroupType: string, data: any): any {
        let temp;
        switch (permissionGroupType) {
            case 'Dashboard':
                temp = data.filter(x => x >= 200 && x <= 299).sort();
                break;
            case 'DashboardGroup':
                temp = data.filter(x => x >= 100 && x <= 199).sort();
                break;
            case 'DataSource':
                temp = data.filter(x => x >= 400 && x <= 499).sort();
                break;
            case 'DashboardOfGroup':
                temp = data.filter(x => x >= 200 && x <= 299).sort();
                break;
          case 'Chart':
            temp = data.filter(x => x >= 500 && x <= 599).sort();
            break;
        }
        return temp ? temp : [];
    }

    private findRole(type: string, roleId: any) {
        const defaultRoles = [...this.defaultWorkspaceRoles$?.value];
        let result = [];
        if (type === 'DashboardGroup') {
            defaultRoles[0].forEach(role => {
                if (role.id === roleId) {
                    result.push(this.filterData(type, role.permissions));
                }
            });
            defaultRoles[1].forEach(role => {
                if (role.id === roleId) {
                    result.push(this.filterData('Dashboard', role.permissions));
                }
            });

        } else {
            defaultRoles.forEach(role => {
                if (role.id === roleId) {
                    result = this.filterData(type, role.permissions);
                }
            });
        }
        return result;
    }

    private mapPermissionsDashboardOrDataSource(user, permissionType): void {
        const permissions = new DefaultPermissions();
        user.permissionsSelected = permissions.mapSpecificPermissions(user.permissionsSelected,permissionType,false);
        user.permissionsBlocked = permissions.mapSpecificPermissions(user.permissionsBlocked,permissionType,true);
    }

    private mapPermissionsDashboardGroup(user): void {
      const permissions = new DefaultPermissions();
        user.permissionsSelected = {
          dashboard:  permissions.mapSpecificPermissions
          ( user.permissionsSelected.dashboard,'Dashboard',false),
          dashboardGroup:  permissions.mapSpecificPermissions
          ( user.permissionsSelected.dashboardGroup,'DashboardGroup',false),
        };
        user.permissionsBlocked = {
          dashboard:  permissions.mapSpecificPermissions
          ( user.permissionsBlocked.dashboard,'Dashboard',true),
          dashboardGroup:  permissions.mapSpecificPermissions
          ( user.permissionsBlocked.dashboardGroup,'DashboardGroup',true),
        };
    }
}
